export function includeJavaScript(url: string, loaded: () => void): void {
    let scriptTag = window.document.createElement('script');
    scriptTag.lang = 'application/javascript';
    scriptTag.src = url;
    scriptTag.addEventListener('load', loaded);
    window.document.head.appendChild(scriptTag);
}
